import { InputBlock } from '@coast/schemas/index';
import { useCallback, useMemo } from 'react';
import { Text } from '@shared/components/Text';
import { useCardFormContext } from '@shared/components/blocks/contexts/form';
import { getTextPropsFromTextStyle } from '@shared/components/blocks/utils';
import { renderToggle } from './input';
import { MBCardInputBlockBase } from './input/base';

interface Props {
  block: InputBlock;
}

export function MBCardInputBlockToggle({ block }: Props) {
  const { setFieldValue, values } = useCardFormContext();
  const textProps = getTextPropsFromTextStyle(block.textStyle);

  const value = values[block.name];
  const onChange = useCallback(
    (updatedValue: boolean) => setFieldValue(block.name, updatedValue),
    [setFieldValue, block.name],
  );

  const renderRight = useMemo(() => () => renderToggle(value, onChange), [value, onChange]);

  return (
    // @ts-expect-error -- strict migration
    <MBCardInputBlockBase block={block} renderLabel={null} renderRight={renderRight}>
      <Text {...textProps}>{block.label}</Text>
    </MBCardInputBlockBase>
  );
}
